/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
window.corpBehaviours = window.corpBehaviours || {};
corpBehaviours.appMenuBehaviour = {
    properties: {
        userId: {
            type: String
        },
        corpId: {
            type: String
        }
    },
    fetchMenuProfileData: function() {
        var appDataElement = document.getElementById("page-title-label");
        return !_.isEmpty(appDataElement.appData.menuProfiles) ? appDataElement.appData.menuProfiles : appDataElement.appData;
    },
    // Writing below function so that the component can be used anywhere even without loading library function from lodash. 
    // Hence, can be used in pre-login flows ( before lodash is loaded ) too.
    _ifUndefined: function(objectArg) {
        if (typeof objectArg === "undefined")
            return true;
        return false;
    },
    validateActionOnButton: function(menuId, event) {
        var menuProfileData = this.fetchMenuProfileData();
        // Below condition is when user does not pass any menuId and does not want any validation, such as in cancel button or menuId passed is correct
        if (this._ifEmptyString(menuId) || (menuProfileData && menuProfileData.indexOf(menuId) >= 0)) {
            // stop propagation added so that user cannot put on-tap from the host component directly.
            // This will disable using on-tap from the host component
            event.stopPropagation();
            this.fire('tap-callback', event);
        } else {
            this.fire("oe-show-message", getLabel('l_PermissionErrorMessage'));
        }
    },
    validateElement: function(menuId) {
        var menuProfileData = this.fetchMenuProfileData();
        if (this._ifEmptyString(menuId) || (menuProfileData && menuProfileData.indexOf(menuId) >= 0)) {
            // console.log(false);
            return false;
        } else {
            // console.log(true);
            return true;
        }
    },
    validateActionOnUserAndMenu: function(menuId) {
        this._routeChanged();
        // Below condition is when user does not pass any menuId and does not want any validation, such as in cancel button
        var menuProfileData = this.fetchMenuProfileData();
        if (this._ifEmptyString(menuId) || (menuProfileData && menuProfileData.indexOf(menuId) >= 0)) {
            return true;
        } else {
            return false;
        }
    },
    // _setUrl: function(menuId, url) {
    _setUrl: function (menuId, url, subItem = null) {
        var message = "";
        // Polymer3 upgrade - temporarily commenting the menu access check, as this feature is not available yet in Polymer3 branch.
        // TODO: this needs to be enabled as part of master merge.
        if (!this.validateActionOnUserAndMenu(menuId)) {
            url = "/error-msg";
            message = getLabel('l_AccessDeniedMessage');
        }
        // window.oe_navigate_to(url, { "description": message });
        //this.fire("menu-data-updated", { detail: { menuItem: subItem } });
        window.oe_navigate_to(url, { "menuItem": subItem });
        this.fire("menu-data-updated", { data: subItem });
        this.fire("close-profile-popup", {});
        //this.dispatchEvent(new CustomEvent('menu-data-updated', { detail: { menuItem: subItem } }));

    },
    _ifEmptyString: function(stringArg) {
        if (this._ifUndefined(stringArg) || stringArg === null || stringArg === '')
            return true;
        return false;
    }
};